var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10.1217,
    rx: 0.5,
    transform: "matrix(0.707029 0.707184 -0.707029 0.707184 7.15625 0)",
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69922 4.53828L4.40625 3.8311L7.51134 6.93687C7.70658 7.13216 7.70658 7.44877 7.51134 7.64406C7.3161 7.83934 6.99955 7.83934 6.80431 7.64406L3.69922 4.53828Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.353514 1.19578C0.158273 1.00049 0.158274 0.683877 0.353515 0.488594C0.548755 0.29331 0.865303 0.29331 1.06054 0.488594L3.8685 3.29717L3.16147 4.00435L0.353514 1.19578Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.7e3d892321c7ec1d16b26b99dba96f55.svg";
export { ForwardRef as ReactComponent };